const cleanHubData = {
  current: '',
  status: '',
  tool: {
    status: '',
    info: {
      id: 0,
      friendlyName: '',
      serialNumber: 0
    }
  },
  device: {
    status: '',
    info: {
      id: 0,
      friendlyName: '',
      armFirmware: 0,
      hwRevision: 0,
      isWifi: false,
      ppcFirmware: 0,
      serialNumber: 0,
      vin: ''
    },
    stats: {
      isAvailable: false,
      v: 0,
      rtt: 0,
      rssi: '',
      rx: 0,
      tx: 0
    }
  },
  pairInfo: {
    appLayerInterface: 0,
    appLayerProtocol: 0,
    serviceRequestId: 0,
    shopSerialNumber: 0,
    toolSerialNumber: 0
  },
  error: ''
}
const defaultServiceRequest = {
  Id: 0,
  RONumber: '',
  ScanReport: {
    TimeCompleted: null,
    IsFollowupScan: 0,
    MSRP: 0,
    Discount: 0
  },
  Status: {
    Name: ''
  },
  Location: {
    Name: ''
  },
  ScanType: {
    Name: ''
  },
  Contact: {
    GivenName: '',
    FamilyName: '',
    PhoneNumber: '',
    Email: ''
  },
  Vehicle: {
    VIN: '',
    Year: 0,
    Make: ''
  },
  Assigned: {
    MasterTechnician: '',
    MasterTechEmail: ''
  }
}

export default () => ({
  cleanHubData: cleanHubData,
  cleanServiceRequest: defaultServiceRequest,
  hubData: cleanHubData,
  requests: [],
  tools: [],
  shopDevices: [],
  techs: [],
  connectedDevices: [],
  statisticInterval: 0,
  serviceRequest: null,
  waitingChats: []
})



// WEBPACK FOOTER //
// ./src/store/modules/astechhub/state.js